import {Button, Space, Stack, Text} from "@mantine/core";
import {ApiResponseDataType} from "../common/utilities";
import React, {useState} from "react";
import TableAttributeModel from "../Table/TableAttributeModel";
import {modals} from "@mantine/modals";
import TableAttributeInput from "./TableAttributeInput";

export default function CreateUpdateNewTableItem({attributes, currentItem, defaultValues, onSubmit}: {
    attributes: TableAttributeModel[],
    currentItem?: ApiResponseDataType,
    defaultValues?: Record<string, any>,
    onSubmit: (newItem: ApiResponseDataType) => Promise<string | undefined>
}) {
    const [creatingNewItem, setCreatingNewItem] = useState(false);
    const [newItemError, setNewItemError] = useState<Error | undefined>(undefined);
    const [newItem, setNewItem] = useState<ApiResponseDataType>({
        ...attributes.reduce((acc, attribute) => {
            acc[attribute.name] = attribute.type === 'string[]' ? [] : attribute.type === 'string' ? '' : attribute.type === 'number' ? -1 : false;
            return acc;
        }, {} as ApiResponseDataType),
         ...defaultValues, 
        ...Object.keys(currentItem || {}).reduce((acc, key) => {
            if (currentItem && currentItem[key] === undefined) {
                acc[key] = typeof currentItem[key] === 'string' ? '' : -1;
            } else if (currentItem) {
                acc[key] = currentItem[key];
            }
            return acc;
        }, {} as ApiResponseDataType),
    });

    return <Stack>
    
{attributes.map((attribute) => {
  const isSnoField = attribute.name.toLowerCase() === 'sno';
  const isEmailField = attribute.name.toLowerCase() === 'email';

  return (
    <TableAttributeInput
      key={attribute.name}
      value={newItem[attribute.name]}
      attribute={attribute}
      disabled={
        currentItem !== undefined && (attribute.primary || isEmailField)
      }
      onChange={(value) => setNewItem({ ...newItem, ...value })}
    />
  );
})}


        <Space px="md"/>
        {newItemError && <Stack>
            <Text c={'red'}>{newItemError?.message}</Text>
            <Space h={'md'}/>
        </Stack>}
        <Button
            disabled={attributes.some((attribute) => attribute.required && !(attribute.autoGenerated && currentItem === undefined) && (newItem[attribute.name] === '' || newItem[attribute.name] === -1))}
            onClick={async () => {
                setCreatingNewItem(true);
                // trim string values
                Object.keys(newItem).forEach((key) => {
                    if (typeof newItem[key] === 'string')
                        newItem[key] = (newItem[key] as string).trim();
                })
                const result = await onSubmit(newItem)
                setCreatingNewItem(false);
                if (result) {
                    setNewItemError(new Error(result));
                } else
                    modals.closeAll();
            }} loading={creatingNewItem}>{currentItem ? "Update" : "Create"}</Button>
    </Stack>
}
